import React from 'react'
import { PageHero } from '../components'

const Checkout = () => {
    return (
        <>
            <PageHero title='Checkout'/>
            <div className='checkout'>
                <div className="checkout__title">
                    <h2>Checkout</h2>
                </div>    
            </div>
        </>
    )
}

export default Checkout